const INVALID_DATE = "n/c";

export default (timestamp, locale = 'fr') => {
  if (!timestamp) {
    return INVALID_DATE;
  }

  let date;

  try {
    date = new Date(timestamp).toLocaleDateString(locale);
  } catch (err) {
    date = INVALID_DATE;
  }

  return date;
};



// WEBPACK FOOTER //
// ./src/utils/convertTimestampToDate.js